import React, { Component } from "react";

import QuestionCreatorItems from "./QuestionCreatorItems/QuestionCreatorItems";

import "./styles.css";

class QuestionCreatorItemsMenu extends Component {
  constructor() {
    super();

    this.itemDescriptionChanger = this.changeItemDescription.bind(this);
    this.itemCheckChanger = this.changeItemCheckStatus.bind(this);
    this.itemFeedbackChanger = this.changeItemFeedback.bind(this);
    this.toggleFeedback = this.toggleItemFeedback.bind(this);

    this.itemCreator = this.handleNewItem.bind(this);
    this.itemDeleter = this.removeItem.bind(this);
  }

  changeItemDescription(itemIndex, newDescription) {
    const index = this.props.itemsData.findIndex(
      item => item.itemIndex === itemIndex
    );

    this.props.itemsData[index].description = JSON.stringify(newDescription);

    this.setState(
      () => this.props.itemsData,
      () => {
        this.props.updateState({ items: this.props.itemsData });
      }
    );
  }

  changeItemFeedback(itemIndex, newFeedback) {
    const index = this.props.itemsData.findIndex(
      item => item.itemIndex === itemIndex
    );

    this.props.itemsData[index].feedback = newFeedback;

    this.setState(this.props.itemsData);
  }

  changeItemCheckStatus(itemIndex, checkStatus) {
    const index = this.props.itemsData.findIndex(
      item => item.itemIndex === itemIndex
    );

    this.props.itemsData[index].check = checkStatus;

    this.props.itemsData.forEach(item => {
      if (
        this.props.questionState.currentQuestionTypeId === 2 &&
        item.itemIndex !== itemIndex
      )
        item.check = false;
    });

    this.setState(
      () => this.props.itemsData,
      () => this.props.updater()
    );
  }

  toggleItemFeedback(itemIndex) {
    const index = this.props.itemsData.findIndex(
      item => item.itemIndex === itemIndex
    );

    this.props.itemsData[index].itemFeedbackOn =
      !this.props.itemsData[index].itemFeedbackOn;

    this.setState(this.props.itemsData);
  }

  handleNewItem(newItemIndex) {
    const index = this.props.itemsData.findIndex(
      item => item.itemIndex === newItemIndex
    );
    this.props.itemsData[index].newItem = false;

    this.props.itemsData.push({
      itemIndex: ++newItemIndex,
      description: '[{"type":"paragraph","children":[{"text":""}]}]',
      itemFeedbackOn: false,
      feedback: null,
      check: false,
      fatherItemId: null,
      newItem: true
    });

    this.setState(
      () => this.props.itemsData,
      () => this.props.updater()
    );
  }

  removeItem(itemIndex) {
    const index = this.props.itemsData.findIndex(
      item => item.itemIndex === itemIndex
    );

    if (this.props.itemsData.length >= 3) {
      this.props.itemsData.splice(index, 1);

      this.setState(
        () => this.props.itemsData,
        () => this.props.updater()
      );
    }
  }

  render() {
    return (
      <ul className="question-creator-item-list">
        {this.props.itemsData.map(item => (
          <li key={item.itemIndex}>
            <QuestionCreatorItems
              questionId={this.props.questionState.questionId}
              itemData={item}
              itemTypeId={this.props.questionState.currentQuestionTypeId}
              itemDescriptionChanger={this.itemDescriptionChanger}
              itemFeedbackChanger={this.itemFeedbackChanger}
              itemCheckChanger={this.itemCheckChanger}
              toggleFeedback={this.toggleFeedback}
              createNewItem={this.itemCreator}
              removeItem={this.itemDeleter}
              readOnly={this.props.readOnly}
            />
          </li>
        ))}
      </ul>
    );
  }
}

export default QuestionCreatorItemsMenu;
